import { render } from "./YellowFlower.svg?vue&type=template&id=29dd1912"
const script = {}
script.render = render

export default script